import { CommonActions } from '@react-navigation/native';

/** Authenticated main stack entry — tab shell, not the first registry screen (Consultation). */
export const MAIN_STACK_INITIAL_ROUTE = 'MainTabs' as const;

/** Guest auth stack entry — onboarding / welcome. */
export const AUTH_STACK_INITIAL_ROUTE = 'Main' as const;

/** Reset target for authenticated users (Main stack → Dashboard tab). */
export const AUTHENTICATED_HOME_RESET = {
  index: 0,
  routes: [{ name: 'MainTabs' as const, params: { screen: 'Dashboard' as const } }],
};

/** Reset target for guest users (Auth stack → Main landing). */
export const GUEST_HOME_RESET = {
  index: 0,
  routes: [{ name: 'Main' as const }],
};

export function buildAppRootResetAction(is_authenticated: boolean) {
  return CommonActions.reset(is_authenticated ? AUTHENTICATED_HOME_RESET : GUEST_HOME_RESET);
}
